<template>
    <div class="margin">
        <content-item-container :showWord="true" :isCenter="true" wordPosition="center">
            <div class="reward-box">
                <img class="title" src="../../../assets/images/postalNewCustomer/countdown.png">
                <div class="count-down">
                    <van-count-down v-if="buttonStatus != -1" :time="time" format="HH:mm:ss" @change="timeChange">
                        <template #default="timeData">
                            <span class="block">{{ timeFormat(timeData.hours) }}</span>
                            <span class="block">:</span>
                            <span class="block">{{ timeFormat(timeData.minutes) }}</span>
                            <span class="block">:</span>
                            <span class="block">{{ timeFormat(timeData.seconds) }}</span>
                        </template>
                    </van-count-down>
                </div>
                <img class="text-over" v-if="buttonStatus == -1" src="../../../assets/images/postalNewCustomer/index_text_over.png">
                <img class="red-bag" src="../../../assets/images/postalNewCustomer/icon_red_bag.png">
                <img class="six-text" src="../../../assets/images/postalNewCustomer/six_text.png">
                <div class="remark-text">请在倒计时结束前开通邮储数字人民币钱包并点击下方按钮领取奖励</div>
                <img class="button" :src="buttonImg" @click="getReward">
                <div class="rule-text" @click="howOpenWallet">如何开通数字人民币钱包？</div>
            </div>
        </content-item-container>
    </div>
</template>

<script>
import { stringify } from 'qs'
import contentItemContainer from './ContentItemContainer.vue'

export default {
    components: { contentItemContainer },
    props: {
        endTime: {
            type: [Number, String],
            default: new Date().getTime()
        },
        timestamp: {
            type: [Number, String],
            default: new Date().getTime()
        },
        status: {
            type: [Number, String],
            default: 0
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            buttonStatus: 0,//-1已过期 0已领取 1可领取 2已抢光
            time: 0,
            buttonImg: require('../../../assets/images/postalNewCustomer/button_get_bag.png')
        }
    },
    computed: {
        //时间计算
        getTime() {
            console.log('当前状态', this.status)
            let time = this.endTime + 24 * 3600 * 1000 - this.timestamp
            this.time = time
            if (this.status == 0) {//未领取
                if (time > 0) {
                    this.buttonImg = require('../../../assets/images/postalNewCustomer/button_get_bag.png')//可领取
                    this.buttonStatus = 1
                } else {
                    this.buttonImg = require('../../../assets/images/postalNewCustomer/button_over.png')//已过期
                    this.buttonStatus = -1
                }
            } else if (this.status == 2) {
                this.time = 0
                this.buttonImg = require('../../../assets/images/postalNewCustomer/button_nothing.png')//已抢光
                this.buttonStatus = 2
            } else {
                this.time = 0
                this.buttonImg = require('../../../assets/images/postalNewCustomer/button_get.png')//已领取
                this.buttonStatus = 0
            }
            return this.buttonImg
        },
    },
    created() {
    },
    mounted() {
        console.log(this.getTime)
    },
    beforeDestroy() { },
    methods: {
        timeFormat(value) {
            if (!value) return '00'
            else if (value < 10) return '0' + JSON.stringify(value)
            else return value
        },
        howOpenWallet() {
            this.$emit('howOpenWallet')
        },
        //领取奖励
        getReward() {
            this.$emit('getReward', this.buttonStatus)
        },
        timeChange(timeData) {
            if (this.status == 0 && timeData.hours == 0 && timeData.minutes == 0 && timeData.seconds) {
                this.buttonImg = require('../../../assets/images/postalNewCustomer/button_over.png')//已过期
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./function";
.margin {
    margin-bottom: pxvw(20);
    .reward-box {
        padding: pxvw(76) pxvw(58) pxvw(48);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .title {
            width: pxvw(353);
        }
        .reward-text {
            font-size: pxvw(26);
            width: pxvw(548);
            text-align: justify;
            color: #898989;
            line-height: pxvw(40);
        }
        .button-sign-up {
            width: pxvw(522);
            height: pxvw(94);
            font-size: 0;
            margin-top: pxvw(36);
        }
        .count-down {
            padding-top: pxvw(30);
            .block {
                padding-top: pxvW(2);
                font-size: pxvw(48);
                font-weight: bold;
                line-height: pxvw(40);
                background: linear-gradient(to bottom, #73dbac, #46ba93);
                -webkit-background-clip: text;
                color: transparent;
                // display: inline-block;
            }
        }
        .red-bag {
            width: pxvw(304);
            margin-top: pxvw(48);
        }
        .six-text {
            width: pxvw(385);
            margin-top: pxvw(50);
        }
        .remark-text {
            font-size: pxvw(26);
            color: #898989;
            margin-top: pxvw(24);
            width: pxvw(522);
        }
        .button {
            height: pxvw(94);
            margin-top: pxvw(48);
        }
        .rule-text {
            font-size: pxvw(25);
            color: #4fdcd6;
            text-decoration: underline;
            text-decoration-color: #4fdcd6;
            margin-top: pxvw(32);
        }
        .text-over {
            width: pxvw(139);
            margin-top: pxvw(30);
            font-size: 0;
        }
    }
}
</style>